"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   * [0, 0, 0, 0],
   * [0, 0, 0, 0],
   * [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState){
        const defaultBoard = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.initialSnapshot = JSON.stringify(initialState || defaultBoard);
        this.board = JSON.parse(this.initialSnapshot);
        this.status = "idle";
        this.score = 0;
    }
    moveLeft() {
        if (this.status !== "playing") return;
        const deskBefore = JSON.stringify(this.board);
        for(let i = 0; i < 4; i++){
            const row = this.board[i];
            const filteredRow = row.filter((num)=>num !== 0);
            for(let j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                filteredRow[j] = filteredRow[j] * 2;
                this.score += filteredRow[j];
                if (filteredRow[j] === 2048) this.status = "win";
                filteredRow.splice(j + 1, 1);
            }
            while(filteredRow.length < 4)filteredRow.push(0);
            this.board[i] = filteredRow;
        }
        const deskAfter = JSON.stringify(this.board);
        if (deskBefore !== deskAfter) this.addRandomTile();
        if (this.possibleMove() === false && this.status !== "win") this.status = "lose";
    }
    moveRight() {
        if (this.status !== "playing") return;
        const deskBefore = JSON.stringify(this.board);
        for(let i = 0; i < 4; i++){
            const row = [
                ...this.board[i]
            ];
            row.reverse();
            const filteredRow = row.filter((num)=>num !== 0);
            for(let j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                filteredRow[j] = filteredRow[j] * 2;
                this.score += filteredRow[j];
                if (filteredRow[j] === 2048) this.status = "win";
                filteredRow.splice(j + 1, 1);
            }
            while(filteredRow.length < 4)filteredRow.push(0);
            this.board[i] = filteredRow.reverse();
        }
        const deskAfter = JSON.stringify(this.board);
        if (deskBefore !== deskAfter) this.addRandomTile();
        if (this.possibleMove() === false && this.status !== "win") this.status = "lose";
    }
    moveUp() {
        if (this.status !== "playing") return;
        const deskBefore = JSON.stringify(this.board);
        for(let i = 0; i < 4; i++){
            const column = [
                this.board[0][i],
                this.board[1][i],
                this.board[2][i],
                this.board[3][i]
            ];
            const filteredRow = column.filter((num)=>num !== 0);
            for(let j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                filteredRow[j] = filteredRow[j] * 2;
                this.score += filteredRow[j];
                if (filteredRow[j] === 2048) this.status = "win";
                filteredRow.splice(j + 1, 1);
            }
            while(filteredRow.length < 4)filteredRow.push(0);
            for(let j = 0; j < 4; j++)this.board[j][i] = filteredRow[j];
        }
        const deskAfter = JSON.stringify(this.board);
        if (deskBefore !== deskAfter) this.addRandomTile();
        if (this.possibleMove() === false && this.status !== "win") this.status = "lose";
    }
    moveDown() {
        if (this.status !== "playing") return;
        const deskBefore = JSON.stringify(this.board);
        for(let i = 0; i < 4; i++){
            const column = [
                this.board[0][i],
                this.board[1][i],
                this.board[2][i],
                this.board[3][i]
            ];
            column.reverse();
            const filteredRow = column.filter((num)=>num !== 0);
            for(let j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                filteredRow[j] = filteredRow[j] * 2;
                this.score += filteredRow[j];
                if (filteredRow[j] === 2048) this.status = "win";
                filteredRow.splice(j + 1, 1);
            }
            while(filteredRow.length < 4)filteredRow.push(0);
            filteredRow.reverse();
            for(let j = 0; j < 4; j++)this.board[j][i] = filteredRow[j];
        }
        const deskAfter = JSON.stringify(this.board);
        if (deskBefore !== deskAfter) this.addRandomTile();
        if (this.possibleMove() === false && this.status !== "win") this.status = "lose";
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.board;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    possibleMove() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (this.board[i][j] === 0) return true;
        }
        for(let i = 0; i < 4; i++){
            const row = this.board[i];
            for(let j = 0; j < 3; j++){
                if (row[j] === row[j + 1]) return true;
            }
        }
        for(let i = 0; i < 4; i++){
            const column = [
                this.board[0][i],
                this.board[1][i],
                this.board[2][i],
                this.board[3][i]
            ];
            for(let j = 0; j < 3; j++){
                if (column[j] === column[j + 1]) return true;
            }
        }
        return false;
    }
    addRandomTile() {
        const emptyCells = [];
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.board[i][j] === 0) emptyCells.push({
                row: i,
                column: j
            });
        }
        if (emptyCells.length === 0) return;
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        const newNumber = Math.random() < 0.9 ? 2 : 4;
        const randomCell = emptyCells[randomIndex];
        this.board[randomCell.row][randomCell.column] = newNumber;
    }
    /**
   * Starts the game.
   */ start() {
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    /**
   * Resets the game.
   */ restart() {
        this.score = 0;
        this.status = "idle";
        this.board = JSON.parse(this.initialSnapshot);
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
document.addEventListener("DOMContentLoaded", ()=>{
    const start = document.querySelector(".start");
    const cells = document.querySelectorAll(".field-row");
    const startMessage = document.querySelector(".message-start");
    const score = document.querySelector(".game-score");
    const winMessage = document.querySelector(".message-win");
    const losemessage = document.querySelector(".message-lose");
    let k = 1;
    start.addEventListener("click", ()=>{
        if (k % 2 !== 0) {
            $09e991522ca7e64e$var$game.start();
            render();
            start.textContent = "Restart";
            start.classList.remove("start");
            start.classList.add("restart");
            k++;
            startMessage.classList.add("hidden");
        } else if (k % 2 === 0) {
            if (!losemessage.classList.contains("hidden")) losemessage.classList.add("hidden");
            $09e991522ca7e64e$var$game.restart();
            render();
            start.textContent = "Start";
            start.classList.remove("restart");
            start.classList.add("start");
            k++;
            startMessage.classList.remove("hidden");
        }
    });
    function render() {
        const board = $09e991522ca7e64e$var$game.getState();
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            const number = board[i][j];
            const cell = cells[i].children[j];
            cell.textContent = number === 0 ? "" : number;
            cell.className = "field-cell";
            if (number !== 0) cell.classList.add(`field-cell--${number}`);
        }
    }
    document.addEventListener("keydown", (e)=>{
        if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
        switch(e.key){
            case "ArrowLeft":
                $09e991522ca7e64e$var$game.moveLeft();
                score.textContent = $09e991522ca7e64e$var$game.getScore();
                statusMessage();
                break;
            case "ArrowRight":
                $09e991522ca7e64e$var$game.moveRight();
                score.textContent = $09e991522ca7e64e$var$game.getScore();
                statusMessage();
                break;
            case "ArrowUp":
                $09e991522ca7e64e$var$game.moveUp();
                score.textContent = $09e991522ca7e64e$var$game.getScore();
                statusMessage();
                break;
            case "ArrowDown":
                $09e991522ca7e64e$var$game.moveDown();
                score.textContent = $09e991522ca7e64e$var$game.getScore();
                statusMessage();
                break;
            default:
                return;
        }
        render();
    });
    function statusMessage() {
        const statusGame = $09e991522ca7e64e$var$game.getStatus();
        if (statusGame === "win") winMessage.classList.remove("hidden");
        else if (statusGame === "lose") losemessage.classList.remove("hidden");
    }
});


//# sourceMappingURL=index.844d259f.js.map
